/**
 * @desc 查询车辆类型列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(): Promise<BaseResponse<defs.ResultBean<Array<defs.Models>>>> {
  return fetch({
    url: config.API_HOST + '/dict/findVehicleTypeList',
    data: undefined,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
